import {
    FilterButton,
    SearchInput,
    SelectInput,
    BooleanInput,
    FilterForm,
    Button,
    useListContext,
} from 'react-admin';
import { Box, Stack, SxProps, Theme } from '@mui/material';

export const SupplyListFilter = ({
    disableSaveQuery,
    sx,
}: {
    disableSaveQuery?: boolean;
    sx?: SxProps<Theme>;
}) => {
    const { setFilters, filterValues } = useListContext();

    const supplyFilters = [
        <SearchInput
            key="search"
            source="search"
            alwaysOn
            placeholder="Search name, description, type..."
        />,
        <SelectInput
            key="enabled"
            source="enabled"
            label="Status"
            alwaysOn
            choices={[
                { id: true, name: 'Enabled' },
                { id: false, name: 'Disabled' },
            ]}
        />,
        <BooleanInput
            key="price"
            source="price"
            label="Not for sale"
            alwaysOn
            format={value => value === 'is.null'}
            parse={checked => (checked ? 'is.null' : null)}
        />,
    ];

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    const handleClearFilters = () => {
        setFilters({});
    };

    return (
        <Box minWidth="10em" maxWidth="18em" order={-1} mr={2} sx={sx}>
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
                <FilterButton
                    filters={supplyFilters}
                    disableSaveQuery={disableSaveQuery}
                />
                <Button
                    disabled={!hasFilters}
                    label="Clear all"
                    onClick={handleClearFilters}
                    variant="outlined"
                    size="small"
                />
            </Stack>
            <FilterForm filters={supplyFilters} />
        </Box>
    );
};
